import { Establishment } from './';

export interface FeedCategory {
  id: string;
  title: string;
  places: Establishment[];
}
